import { Component, Input, OnInit, OnDestroy, SimpleChanges } from "@angular/core";
import {default as GridColumnsJSON} from './event-tree-grid-columns.json';
import { ConstantService } from "app/Shared/Services/constant-service";
import { GridService } from "app/Shared/Services/grid.service";
import { TreeNode,MessageService } from "primeng/api";
import { HttpErrorResponse } from "@angular/common/http";
import { EventTreeService } from "./event-tree.service";
import { UserService } from "app/Shared/Services/user.service";
import {default as _} from 'lodash';
import { LowerCasePipe, TitleCasePipe, DatePipe, CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { MatChipsModule } from "@angular/material/chips";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatTooltipModule } from "@angular/material/tooltip";
import { ButtonModule } from "primeng/button";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DialogModule } from "primeng/dialog";
import { TableModule } from "primeng/table";
import { TreeTableModule } from "primeng/treetable";
import { generateCsv, asBlob } from "export-to-csv";
import { saveAs } from 'file-saver';
import { ToastModule } from "primeng/toast";
import { Subscription } from "rxjs";
import { MatCheckboxChange, MatCheckboxModule } from '@angular/material/checkbox';

@Component({
    selector: 'app-event-tree',
    imports: [CommonModule, ButtonModule, MatTooltipModule, TableModule, MatExpansionModule,
        MatChipsModule, MatProgressSpinnerModule, MatChipsModule,
        LowerCasePipe, ConfirmDialogModule, FormsModule,
        DialogModule, TreeTableModule, ToastModule, MatCheckboxModule
    ],
    templateUrl: './event-tree.componenet.html',
    styleUrls: ['./event-tree.componenet.scss']
})
export class EventTreeComponent implements OnInit, OnDestroy {
  @Input('SelectedRow') selectedRow: any = [];
  isDataLoading: boolean = true;
  @Input('showFilter') showFilter: boolean = true;
  @Input('rows') rows: number | any= 20;
  @Input('pageName') pageName!: string;
  gridColumns = GridColumnsJSON;
  selectedNodes3 = [];
  buttonCaption: string = 'Collapse'
  cols :any= [];
  nodeSelectCount: number = 0;
  nodeUnselectCount: number = 0;
  selectedNode!: TreeNode;
  subscription!: Subscription;
  index = 0;
  reportDate: string = "";
  todate: string = "";
  orderID: string = "";
  symbol: string = "";
  type: string = "";
  side: string = "";
  orderDate: string = "";
  firmROEID: string = "";
  startLimit: string = '0';
  endLimit: string = '20';

  eventTreeData: TreeNode[] = [];
  totalRecords:any=0;
  checkedUseOrderKeyDate: boolean = true;
  parentDetail: any = [];

  constructor(public gridService: GridService,
    public constantService: ConstantService,
    public eventTreeService: EventTreeService,
    public userService: UserService,
    public messageService: MessageService,
    public date: DatePipe) {
    this.getColumns();
  }

  ngOnInit() {}

  /**
   * We've received fresh/new selectedRow each time when we open Event-Tree Component thus we shifted
   * our initial web service API from ngOnInit to ngOnChanges
   */
  ngOnChanges(changes: SimpleChanges) {
    this.callGetDataAPI();
  }

  callGetDataAPI() {
    this.isDataLoading = true;
    this.collapseAll(this.eventTreeData);
    let row = this.selectedRow[0];
    this.firmROEID = row['firmROEID'];
    this.orderID = row['orderID'];
    this.reportDate = row['reportDate'];
    this.todate = row['reportDate'];
    this.type = row['type'];
    this.symbol = row['symbol'];
    this.side = row['side'];
    this.orderDate = row['orderKeyDate'];

    let clonedRow = _.cloneDeep(row);
    clonedRow.orderKeyDate = (this.checkedUseOrderKeyDate ? clonedRow.orderKeyDate : ''); // Applied Manual selection of OrderLeyDate Search
    clonedRow.searchParent = false;

    this.eventTreeService.getData(clonedRow, "parent", this.startLimit, this.endLimit)
    .subscribe({
      next: (Element:any) => {
        this.isDataLoading = false;
        let dataset: any = Element;
        this.eventTreeData = [];
        if (dataset.data) {
          this.eventTreeData = dataset.data;
          this.totalRecords = this.eventTreeData.length;
        }
      },
      error: (err: HttpErrorResponse) => {
        this.isDataLoading = false;
      }
    });
  }

  callGetParentDataAPI() {
    this.isDataLoading = true;
    this.collapseAll(this.eventTreeData);
    this.parentDetail = Object.keys(this.parentDetail).length > 0 ? this.parentDetail : this.selectedRow[0];

    let row = this.parentDetail;

    let clonedRow = _.cloneDeep(row);
    clonedRow.orderKeyDate = (this.checkedUseOrderKeyDate ? clonedRow.orderKeyDate : ''); // Applied Manual selection of OrderLeyDate Search
    clonedRow.searchParent = true;

    this.eventTreeService.getData(clonedRow, "parent", this.startLimit, this.endLimit)
    .subscribe({
      next: (Element:any) => {
        this.isDataLoading = false;
        let dataset: any = Element;
        if (dataset.data && dataset.data.length > 0) {
          this.parentDetail = dataset.data[0]['data'];

          /* Check Next Level of Parent is Existing in TreeViewer OR not */
            // Find the existance of Parent object with Existing Parent-Child Tree
            let existingParentObjectIndex = this.eventTreeData.findIndex((eventTreeObject: any) => eventTreeObject['data'].firmROEID === dataset.data[0]['data']['firmROEID']);

            // If the Parent object is found, Pick it up, remove it and put it at the Top of Parent-Child Tree 
            // Otherwise add the found Parent Object from Backend DB at the Top of Parent-Child Tree
            if (existingParentObjectIndex !== -1) {
              let existingParentObject: any = this.eventTreeData.filter((eventTreeObject: any) => eventTreeObject['data'].firmROEID === dataset.data[0]['data']['firmROEID']);

              this.eventTreeData.splice(existingParentObjectIndex, 1);

              this.eventTreeData = [...existingParentObject, ...this.eventTreeData];
            } else {
              this.eventTreeData = [...dataset.data, ...this.eventTreeData];
              this.totalRecords = this.eventTreeData.length;
            }
          /* End of Check Next Level of Parent is Existing in TreeViewer OR not */
        }
      },
      error: (err: HttpErrorResponse) => {
        this.isDataLoading = false;
      }
    });

  }

  getColumns() {
    let column: any = this.gridColumns;
    if (column != null || column != undefined) {
      this.cols = this.gridService.getGridColumnsOftree(column);
    }
  }
  
  exportToCSV(exportType?: any) {
  if(this.userService.enableFileExport()){
    let initialTime = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'});
    this.messageService.add({ severity: 'info', summary: 'File', detail: 'Please wait.. Preparing export file to download..' });

    const filename='RSMS_Parent_Child_Event_Tree_' + this.type + '_' + this.orderID + '_' + this.userService.getyyyyMMddDateFormate(new Date());

    this.eventTreeService.exportToCSV(this.eventTreeData)
    .subscribe(Element => {
      let dataset: any = Element;
      let data = dataset.Data;
      if (data.length > 0) {
        data.forEach((col:any) => {
          col.timeInForce = (typeof col.timeInForce === 'object' ? JSON.stringify(col.timeInForce) : col.timeInForce);
          col.handlingInstructions = (typeof col.handlingInstructions === 'object' ? JSON.stringify(col.handlingInstructions) : col.handlingInstructions);
          col = this.gridService.formatMultiDimensionalColumns(col, this.gridService.multiDimensionalColumns);
        });
        let options:any = {
          fieldSeparator: ',',
          quoteStrings: '"',
          decimalSeparator: '.',
          showLabels: true,
          showTitle: true,
          title:filename,
          useTextFile: false,
          useBom: true,
          useKeysAsHeaders: true,
          filename: filename
        };
        /* Export All Fields OR Export Default Fields CSV */
          let csvGridCols:any = ((exportType==="ExportAll") ? this.eventTreeService.processUniqueFields(data) : this.gridColumns);
          csvGridCols =  _.orderBy(csvGridCols, [gridCol => gridCol.ui_columnname.toLowerCase()], ['asc']);

          let csvGridColsData = [];   
          csvGridColsData.push({'mappingkey':'type', 'ui_columnname': 'Event Type'});
          csvGridColsData.push({'mappingkey':'symbol', 'ui_columnname': 'Symbol'});
          csvGridColsData.push({'mappingkey':'eventTimestamp', 'ui_columnname': 'Event Timestamp'});
          csvGridColsData.push({'mappingkey':'firmROEID', 'ui_columnname': 'Firm ROEID'});    
          csvGridCols.forEach((element:any) => {  
            if(element.mappingkey != 'type' || element.mappingkey != 'symbol' 
            || element.mappingkey != 'eventTimestamp' || element.mappingkey != 'firmROEID'){
              csvGridColsData.push(element);
            }         
          }); 
          /* End of Export All Fields OR Export Default Fields CSV */
        const csv = generateCsv(options)(this.constantService.getExportData(data,csvGridColsData));
        const blob = asBlob(options)(csv);
        saveAs(blob,filename);
        this.messageService.add({ severity: 'success', summary: 'File', detail: 'File Download Successfully' });
        this.userService.logUserActivity('Export CSV' + (typeof this.pageName!=='undefined' ? ' - Event Tree' : ''), this.pageName, {
          'Text1': 'File Download Successfully | ' + (data.length > 0 ? data.length : 0) + ' records downloaded with file name: ' + options.filename + ' with start time: ' + initialTime + ' and end time: ' + new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'}),
          'Text2': 'User Filter Parameters: ' + JSON.stringify(this.selectedRow.filter((filterParam:any) => (filterParam.values != '' || filterParam.values.length > 0)))
        });
      } else {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No data found' });
        this.userService.logUserActivity('Export CSV' + (typeof this.pageName!=='undefined' ? ' - Event Tree' : ''), this.pageName, {
          'Text1': 'No data found',
          'Text2': 'User Filter Parameters: ' + JSON.stringify(this.selectedRow.filter((filterParam:any) => (filterParam.values != '' || filterParam.values.length > 0)))
        });
      }
    });
  }
}

  exapandORcollapse(nodes:any) {
    if (this.buttonCaption === "Expand") {
      this.collapseAll(nodes)
      this.buttonCaption = "Collapse"
    } else if (this.buttonCaption === "Collapse") {
      this.buttonCaption = "Expand"
      this.exapandAll(nodes)
    }
    //refresh the data
    this.eventTreeData = [...this.eventTreeData];
  }
 exapandAll(nodes:any) {
    for (let node of nodes) {
      if (node.children) {
        this.isDataLoading = true;

        let clonedRow = _.cloneDeep(node.data);
        clonedRow.orderKeyDate = (this.checkedUseOrderKeyDate ? clonedRow.orderKeyDate : ''); // Applied Manual selection of OrderLeyDate Search
    
        this.eventTreeService.getData(clonedRow, "child", this.startLimit, this.endLimit)
        .subscribe({
          next: (Element:any) => {
            this.isDataLoading = false;
              let dataset: any = Element;
              if (dataset.data)
                node.children = dataset.data;
              if (node.expanded == false || node.expanded == undefined) {
                node.expanded = true;
                this.exapandAll(node.children);
              }
              this.eventTreeData = [...this.eventTreeData];
            this.totalRecords += dataset.data.length;
          },  
          error: (err: HttpErrorResponse) => {
            this.isDataLoading = false;
          }
          });
      }
    }
    //refresh the data
    this.eventTreeData = [...this.eventTreeData];
  }

  collapseAll(nodes:any) {
    for (let node of nodes) {
      if (node.children) {
        if (node.expanded == true || node.expanded == undefined) {
          node.expanded = false;
          this.collapseAll(node.children);
        }
      }
    }
    //refresh the data
    this.eventTreeData = [...this.eventTreeData];
  }

  nodeSelect(event:any) {
    this.isDataLoading = true;
    this.buttonCaption = "Expand"
    const node = event.node;
    if (event.node.expanded) {
      let clonedRow = _.cloneDeep(node.data);
      clonedRow.orderKeyDate = (this.checkedUseOrderKeyDate ? clonedRow.orderKeyDate : ''); // Applied Manual selection of OrderLeyDate Search

      this.eventTreeService.getData(clonedRow, "child", this.startLimit, this.endLimit)
      .subscribe({
        next: (Element:any) => {
          this.isDataLoading = false;
          let dataset: any = Element;
          if (dataset.data)
            event.node.children = dataset.data;
          //refresh the data
          this.eventTreeData = [...this.eventTreeData];
          this.totalRecords = this.eventTreeData.length + dataset.data.length;
        },
        error: (err: HttpErrorResponse) => {
          this.isDataLoading = false;
        }
      });
        
      event.node.width = this.cols[0].width;
    }
    //refresh the data
    this.eventTreeData = [...this.eventTreeData];
  }

  nodeUnselect(event:any) {
    this.buttonCaption = "Collapse";
    this.eventTreeData = [...this.eventTreeData];
    this.totalRecords = this.eventTreeData.length;
  }

  loadNodes(event:any) {

  }

  showParent() {
    this.callGetParentDataAPI();
  }

  toggleUseOrderKeyDate(event: MatCheckboxChange): void {
    this.checkedUseOrderKeyDate = ((event.checked) ? true : false);
    this.parentDetail = []; // Reset Parent Detail when toggle search with OrderKeyDate
    this.callGetDataAPI();
  }

  getResolutionHeight() {
    return this.constantService.getResolutionHeight() - 60 + 'px';
  }

  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
  }

}